import Footer from "../../../components/footer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { DestinationAccountControllerType } from "../useDestinationAccount";

import { BodyLargeRegular, HeadlineMedium, Highlight } from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";
import { ListContainer, ListItem } from "../../../components/list/List";
import NumberIcon from "../../../components/icons/number-icon";
import { Button } from "@manifesthhqinc/ui-library";

const OpenAndConnectIRAScreen = (props: DestinationAccountControllerType) => {
  const { currentDestinationDetails, onClickContinue, onClickDifferentDestination } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="open-and-connect-ira">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium>Open your traditional (before-tax) IRA. Then connect it to Manifest.</HeadlineMedium>
            <BodyLargeRegular $textAlign="left">Please follow the steps below.</BodyLargeRegular>
          </HeadingContainer>

          <ListContainer name="openIRA">
            <ListItem
              heading={
                <BodyLargeRegular>
                  Visit{" "}
                  <a href={currentDestinationDetails.accountOpeningUrl || ""} target="_blank" rel="noreferrer">
                    <Highlight>{currentDestinationDetails.providerName}</Highlight>
                  </a>{" "}
                  to get started.
                </BodyLargeRegular>
              }
              icon={<NumberIcon iconNumber="1" inverted />}
              iconSpacing="42"
              paddingLeft=""
            />
            <ListItem
              heading={<>Open a traditional (before-tax) IRA, not a rollover IRA.</>}
              icon={<NumberIcon iconNumber="2" inverted />}
              iconSpacing="42"
            />
            <ListItem
              heading={"You'll receive an account number you can use to connect your account in Manifest."}
              icon={<NumberIcon iconNumber="3" inverted />}
              iconSpacing="42"
            />
          </ListContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button
          onClick={onClickDifferentDestination}
          size="large"
          variant="secondary"
          name="chooseDifferentDestination"
        >
          Choose a different destination
        </Button>
        <Button onClick={onClickContinue} size="large" name="connectIRA">
          I've opened my account
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default OpenAndConnectIRAScreen;
